/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiFeedbackResult,
  AiFeedbackResultRequestInput,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Delete AI Feedback Result
 */
export const deleteAiFeedbackResult = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/feedback_results/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAiFeedbackResultMutationKey = () => ['deleteAiFeedbackResult'] as const;

export const getDeleteAiFeedbackResultMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiFeedbackResult>>, TError,DeleteAiFeedbackResultMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiFeedbackResult>>, TError,DeleteAiFeedbackResultMutationVariables, TContext> => {

const mutationKey = getDeleteAiFeedbackResultMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiFeedbackResult>>, DeleteAiFeedbackResultMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAiFeedbackResult(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiFeedbackResultMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiFeedbackResult>>>

    export type DeleteAiFeedbackResultMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteAiFeedbackResultMutationVariables = {id: string}

    /**
 * @summary Delete AI Feedback Result
 */
export const useDeleteAiFeedbackResult = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiFeedbackResult>>, TError,DeleteAiFeedbackResultMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiFeedbackResult>>,
        TError,
        DeleteAiFeedbackResultMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAiFeedbackResultMutationOptions(options), queryClient);
    }
    /**
 * @summary AI Feedback Result Details
 */
export const getAiFeedbackResult = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AiFeedbackResult>(
      {url: `/ai/feedback_results/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetAiFeedbackResultQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'ai','feedback_results',id
    ] as const;
    }


export const getGetAiFeedbackResultQueryOptions = <TData = Awaited<ReturnType<typeof getAiFeedbackResult>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiFeedbackResult>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiFeedbackResultQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiFeedbackResult>>> = ({ signal }) => getAiFeedbackResult(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiFeedbackResult>>, TError, TData>
}

export type GetAiFeedbackResultQueryResult = NonNullable<Awaited<ReturnType<typeof getAiFeedbackResult>>>
export type GetAiFeedbackResultQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary AI Feedback Result Details
 */

export function useGetAiFeedbackResult<TData = Awaited<ReturnType<typeof getAiFeedbackResult>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiFeedbackResult>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiFeedbackResultQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update AI Feedback Result
 */
export const updateAiFeedbackResult = (
    id: MaybeRefOrGetter<string>,
    aiFeedbackResultRequestInput: MaybeRefOrGetter<AiFeedbackResultRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
aiFeedbackResultRequestInput = toValue(aiFeedbackResultRequestInput);

      return axiosClient<AiFeedbackResult>(
      {url: `/ai/feedback_results/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: aiFeedbackResultRequestInput, signal
    },
      );
    }




export const getUpdateAiFeedbackResultMutationKey = () => ['updateAiFeedbackResult'] as const;

export const getUpdateAiFeedbackResultMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiFeedbackResult>>, TError,UpdateAiFeedbackResultMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAiFeedbackResult>>, TError,UpdateAiFeedbackResultMutationVariables, TContext> => {

const mutationKey = getUpdateAiFeedbackResultMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiFeedbackResult>>, UpdateAiFeedbackResultMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateAiFeedbackResult(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiFeedbackResultMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiFeedbackResult>>>
    export type UpdateAiFeedbackResultMutationBody = AiFeedbackResultRequestInput
    export type UpdateAiFeedbackResultMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateAiFeedbackResultMutationVariables = {id: string;data: AiFeedbackResultRequestInput}

    /**
 * @summary Update AI Feedback Result
 */
export const useUpdateAiFeedbackResult = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiFeedbackResult>>, TError,UpdateAiFeedbackResultMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAiFeedbackResult>>,
        TError,
        UpdateAiFeedbackResultMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAiFeedbackResultMutationOptions(options), queryClient);
    }
    /**
 * @summary Create AI Feedback Result
 */
export const createAiFeedbackResult = (
    feedbackId: MaybeRefOrGetter<string>,
    aiFeedbackResultRequestInput: MaybeRefOrGetter<AiFeedbackResultRequestInput>,
 signal?: AbortSignal
) => {
      feedbackId = toValue(feedbackId);
aiFeedbackResultRequestInput = toValue(aiFeedbackResultRequestInput);

      return axiosClient<AiFeedbackResult>(
      {url: `/ai/feedbacks/${feedbackId}/feedback_results`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiFeedbackResultRequestInput, signal
    },
      );
    }




export const getCreateAiFeedbackResultMutationKey = () => ['createAiFeedbackResult'] as const;

export const getCreateAiFeedbackResultMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiFeedbackResult>>, TError,CreateAiFeedbackResultMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiFeedbackResult>>, TError,CreateAiFeedbackResultMutationVariables, TContext> => {

const mutationKey = getCreateAiFeedbackResultMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiFeedbackResult>>, CreateAiFeedbackResultMutationVariables> = (props) => {
          const {feedbackId,data} = props ?? {};

          return  createAiFeedbackResult(feedbackId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiFeedbackResultMutationResult = NonNullable<Awaited<ReturnType<typeof createAiFeedbackResult>>>
    export type CreateAiFeedbackResultMutationBody = AiFeedbackResultRequestInput
    export type CreateAiFeedbackResultMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateAiFeedbackResultMutationVariables = {feedbackId: string;data: AiFeedbackResultRequestInput}

    /**
 * @summary Create AI Feedback Result
 */
export const useCreateAiFeedbackResult = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiFeedbackResult>>, TError,CreateAiFeedbackResultMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiFeedbackResult>>,
        TError,
        CreateAiFeedbackResultMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAiFeedbackResultMutationOptions(options), queryClient);
    }
